import React, { useEffect } from 'react';
import { arrayOf, bool, object } from 'prop-types';
import { useDispatch } from 'react-redux';

import BatchProgressDialog from './BatchProgressDialog';
import useQueue from '../../hooks/useQueue';
import { getRule, saveRule } from '../../actions/ruleActions';

const RuleEnableSelectedModal = ({ onClose, open, rules }) => {
    const dispatch = useDispatch();
    const [queue, runQueue] = useQueue(async (rule, { fulfill, reject}) => {
        try {
            const rulePayload = await dispatch(getRule(rule.id));
            const updatedRule = await dispatch(saveRule({
                ...rulePayload.data,
                enabled: true
            }));
            fulfill({
                item:  rulePayload.data,
                value: updatedRule
            });
        } catch (error) {
            reject({
                error,
                item: rule
            });
        }
    });

    useEffect(() => {
        if (open) {
            runQueue(rules);
        }
    }, [open]);

    useEffect(() => {
        if (queue.complete && queue.successful) {
            onClose();
        }
    }, [queue.complete, queue.successful]);

    return (
        <BatchProgressDialog
            {...queue}
            onClose={onClose}
            open={open}
            title="Enabling Selected Rules"
        />
    );
};

RuleEnableSelectedModal.defaultProps = {
    open:  false,
    rules: []
};

RuleEnableSelectedModal.propTypes = {
    open:  bool,
    rules: arrayOf(object)
};

export default RuleEnableSelectedModal;
